export default __webpack_public_path__ + "static/media/AMS - List All_Dark2.51979f9c.svg";